export default {
  en: {
    generic_error: 'Something went wrong.',
  },
};
